module.exports = __webpack_public_path__ + "img/reg_logo.347f28af.png";